import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import times from 'lodash/times';
import * as styles from './PreShellLoader.css';

const cx = classNames.bind(styles);

function ListItemPreShellLoader({ count }) {
    function renderSMCartItemShell() {
        return (
            <div className={cx('cartItemBlock')}>
                <div className={cx('itemInfoBlock')}>
                    <div className={cx('animatedBlock', 'itemImg')} />
                    <div className={cx('animatedBlock', 'titleLine1')} />
                    <div className={cx('animatedBlock', 'titleLine2')} />
                    <div className={cx('animatedBlock', 'smLine')} />
                    <div className={cx('animatedBlock', 'smLine')} />
                    <div className={cx('animatedBlock', 'smLine')} />
                    <div className={cx('animatedBlock', 'smLine')} />
                </div>
                <div className={cx('contentBlock')}>
                    <div className={cx('animatedBlock', 'quantityBlock')} />
                    <div className={cx('animatedBlock', 'mdLine')} />
                    <div className={cx('animatedBlock', 'mdLine')} />
                </div>
                <div className={cx('fulfilmentBlock')}>
                    <div className={cx('animatedBlock', 'line')} />
                    <div className={cx('animatedBlock', 'blockLine')} />
                </div>
                <div className={cx('separatorLine')} />
            </div>
        );
    }

    function renderCartItemShell() {
        return (
            <div className={cx('cartItemBlock')}>
                <div className={cx('itemInfoBlock')}>
                    <div className={cx('animatedBlock', 'itemImg')} />
                    <div className={cx('animatedBlock', 'titleLine1')} />
                    <div className={cx('animatedBlock', 'titleLine2')} />
                    <div className={cx('animatedBlock', 'smLine')} />
                    <div className={cx('animatedBlock', 'smLine')} />
                </div>
                <div className={cx('contentBlock')}>
                    <div className={cx('quantityBlock')} />
                    <div className={cx('animatedBlock', 'mdLine')} />
                    <div className={cx('animatedBlock', 'mdLine')} />
                </div>
                <div className={cx('separatorLine')} />
            </div>
        );
    }

    return (
        <div>
            <div className={cx('cartItemSm', 'visibleSm')}>
                {times(count, renderSMCartItemShell)}
            </div>
            <div className={cx('cartBlock')}>
                <div className={cx('itemList', 'md12', 'lg8', 'xl8', 'hiddenSm')}>
                    {times(count, renderCartItemShell)}
                </div>
            </div>
        </div>
    );
}

ListItemPreShellLoader.propTypes = {
    count: PropTypes.number,
};

ListItemPreShellLoader.defaultProps = {
    count: 2,
};

export default ListItemPreShellLoader;
